import React from 'react';
import { CircularProgress, Fade } from '@mui/material';

import useSettings from '../../hooks/useSettings';
import Icon from '../../Icon';
import Text from '../../Text';
import ErrorAlert from '../../ErrorAlert';

interface ResultStepProps {
	isProcessing: boolean;
	error?: any;
	updateRefresh: VoidFunction;
}

export default function ResultStep(props: ResultStepProps) {
	const { t } = useSettings();

	return (
		<div className="flex max-w-640 items-center self-center p-16">
			{props.error ? (
				<ErrorAlert error={props.error} />
			) : (
				<>
					<div className="relative inline-flex">
						<CircularProgress
							value={100}
							size={64}
							variant={props.isProcessing ? 'indeterminate' : 'determinate'}
							color={!props.isProcessing ? 'success' : undefined}
							disableShrink={props.isProcessing}
						/>
						<div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center">
							<Fade in={!props.isProcessing} timeout={500}>
								<Icon icon="check-circle" size={60} color="success.main" />
							</Fade>
						</div>
					</div>
					{!props.isProcessing && (
						<Fade in={!props.isProcessing} timeout={550}>
							<div className="ml-16 overflow-auto">
								<Text variant="h6" gutterBottom>
									Operazione completata!
								</Text>
								<Text variant="body2">
									Adesso puoi chiudere questa finestra tramite il bottone "Chiudi" e visualizzare i
									risultati dell'importazione
								</Text>
							</div>
						</Fade>
					)}
				</>
			)}
		</div>
	);
}
